import React, { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  Box,
  Card,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Button,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack5";
import { createAgentApi } from "src/Api/Services/AgentFareRule";
import { Col, Row } from "react-bootstrap";
const AddAgentFareRuleMgtComp = ({ agentList, fetchData, setShow }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      role: "",
      logo: "",
      perAccess: [],
      metaBaseURL: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.username) {
        errors.username = "User Name is required";
      }
      if (!values.password) {
        errors.password = "Password is required";
      }
      if (!values.role) {
        errors.role = "Role is required";
      }
      if (values.perAccess.length === 0) {
        errors.perAccess = "Permission is required";
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSubmitApiCall();
    },
  });
  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    handleChange,
    values,
    setFieldValue,
    setSubmitting,
    resetForm,
    handleBlur,
  } = formik;
  const handleSubmitApiCall = async () => {
    const { perAccess, ...rest } = values;
    try {
      const { data } = await createAgentApi({
        ...rest,
        permissions: {
          pList: [{ name: "farerule", access: perAccess }],
        },
      });
      if (data.status) {
        fetchData();
        resetForm();
        setShow(false);
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setSubmitting(false);
  };
  return (
    <>
      {/* <Card>
        <Box sx={{ p: { xs: 3, md: 5 } }}> */}
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} xs={12} xl={3}>
            <TextField
              type="text"
              placeholder="Enter user name"
              size="normal"
              label="User Name"
              name="username"
              value={values.username}
              onChange={handleChange}
              error={errors.username && touched.username}
              fullWidth
              onBlur={handleBlur}
            />
            {errors.username && touched.username && (
              <FormHelperText error id="component-error-text">
                {errors.username}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={3}>
            <TextField
              type="text"
              placeholder="Enter user password"
              size="normal"
              label="Password"
              name="password"
              value={values.password}
              onChange={handleChange}
              error={errors.password && touched.password}
              fullWidth
              onBlur={handleBlur}
            />
            {errors.password && touched.password && (
              <FormHelperText error id="component-error-text">
                {errors.password}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={3}>
            <FormControl fullWidth size="normal">
              <InputLabel id="demo-simple-select-label">Role</InputLabel>
              <Select
                name="role"
                value={values.role}
                onChange={handleChange}
                error={errors.role && touched.role}
                label="Role"
                onBlur={handleBlur}
              >
                <MenuItem value="user">User</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="agent">Agent</MenuItem>
              </Select>
            </FormControl>
            {errors.role && touched.role && (
              <FormHelperText error id="component-error-text">
                {errors.role}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Logo</InputLabel>
              <Select
                name="logo"
                value={values.logo}
                onChange={handleChange}
                label="Logo"
              >
                {logoList.map((it) => (
                  <MenuItem value={it.value}>{it.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Col>
          <Col md={12} xs={12} xl={4} className="mt-4">
            <TextField
              type="text"
              placeholder="Enter meta base url i.e, http://www.google.com/"
              size="normal"
              label="Meta Base URL"
              name="metaBaseURL"
              value={values.metaBaseURL}
              onChange={handleChange}
              error={errors.metaBaseURL && touched.metaBaseURL}
              fullWidth
              onBlur={handleBlur}
            />
            {errors.metaBaseURL && touched.metaBaseURL && (
              <FormHelperText error id="component-error-text">
                {errors.metaBaseURL}
              </FormHelperText>
            )}
          </Col>
          <Col md={12} xs={12} xl={6}>
            {agentList.length > 0 && (
              <Autocomplete
                multiple
                id="multi-select-autocomplete"
                options={agentList}
                // getOptionLabel={(option) => option}
                value={values.perAccess}
                name="perAccess"
                onChange={(e, value) => setFieldValue("perAccess", value)}
                size="normal"
                fullWidth
                className="mt-4"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Permissions access"
                    variant="outlined"
                    error={errors.perAccess && touched.perAccess}
                    onBlur={handleBlur}
                  />
                )}
              />
            )}
            {errors.perAccess && touched.perAccess && (
              <FormHelperText error id="component-error-text">
                {errors.perAccess}
              </FormHelperText>
            )}
          </Col>
        </Row>
        <div className="text-center mt-4">
          <Button variant="contained" type="submit" disabled={isSubmitting}>
            Submit
          </Button>
        </div>
      </form>
      {/* </Box>
      </Card> */}
    </>
  );
};

export default AddAgentFareRuleMgtComp;
const logoList = [
  { name: "Travomint", value: "Travomint.png" },
  { name: "Wego", value: "wego.png" },
  { name: "Jetcost", value: "jetcost.png" },
  { name: "Jetradar", value: "jetradar.png" },
  { name: "Momondo", value: "momondo.png" },
];
